<div class="sidenav-wrapper" [class.panel-open]="showSubjectsPanel() || showSpecializationsPanel()">
  <!-- Main sidenav menu -->
  <div class="sidenav-container">
    <!-- User info section (visible on mobile) -->
    <div class="user-info-section" (click)="onUserProfileClick()">
      <div class="user-avatar">
        @if (getUserInitials()) {
          <div class="avatar-initials">{{ getUserInitials() }}</div>
        } @else {
          <fa-icon [icon]="faUser" class="avatar-icon"></fa-icon>
        }
      </div>
      <div class="user-details">
        <div class="user-name">
          {{ isLoggedIn() ? getUserDisplayName() : ('dottnet.menu.accedi' | translate) }}
        </div>
      </div>
      <fa-icon [icon]="faChevronRight" class="user-chevron"></fa-icon>
    </div>

    <div class="menu-items">
      @for (item of menuItems(); track item.label; let i = $index) {
        <div class="menu-item" (click)="onMenuItemClick(item, i)">
          <div class="menu-item-content flex-row flex-justify-space-between flex-align-center">
            <div class="menu-item-label">{{ item.label | translate }}</div>
            @if (item.expandable) {
              <fa-icon
                [icon]="item.expanded ? faChevronUp : faChevronRight"
                class="menu-item-icon"
              ></fa-icon>
            }
          </div>
        </div>
        <!-- Children submenu -->
        @if (item.expanded && item.children) {
          <div class="submenu">
            @for (child of item.children; track child.label; let j = $index) {
              <div class="submenu-item" (click)="onChildItemClick(child, i, j, $event)">
                <div class="submenu-item-content flex-row flex-justify-space-between flex-align-center">
                  <div class="submenu-item-label">{{ child.label | translate }}</div>
                  @if (child.expandable) {
                    <fa-icon
                      [icon]="child.expanded ? faChevronUp : faChevronRight"
                      class="submenu-item-icon"
                    ></fa-icon>
                  }
                </div>
              </div>
              <!-- Grandchildren submenu -->
              @if (child.expanded && child.children) {
                <div class="submenu-level-2">
                  @for (grandchild of child.children; track grandchild.label; let k = $index) {
                    <div class="submenu-item-level-2" (click)="onGrandchildItemClick(grandchild, i, j, k, $event)">
                      <div class="submenu-item-content-level-2">
                        <div class="submenu-item-label-level-2">{{ grandchild.label | translate }}</div>
                      </div>
                    </div>
                  }
                </div>
              }
            }
          </div>
        }
      }
    </div>
  </div>

  <!-- Subjects panel (slides in next to main sidenav) -->
  <div class="secondary-panel" [class.visible]="showSubjectsPanel()">
    <dottnet-sidenav-panel
      [items]="subjects()"
      variant="subjects"
      (backClick)="onSubjectsBackClick()"
      (itemClick)="onSubjectClick($event)"
      (showAllClick)="onShowAllSubjects()"
      (searchSubmit)="onSubjectsSearch($event)"
    />
  </div>

  <!-- Specializations panel (slides in next to main sidenav) -->
  <div class="secondary-panel" [class.visible]="showSpecializationsPanel()">
    <dottnet-sidenav-panel
      [items]="specializations()"
      variant="specializations"
      (backClick)="onSpecializationsBackClick()"
      (itemClick)="onSpecializationClick($event)"
      (showAllClick)="onShowAllSpecializations()"
      (searchSubmit)="onSpecializationsSearch($event)"
    />
  </div>
</div>
